import { api } from './api'
import type {
  PcrsClaimInquiryParams,
  PcrsClaimInquiryResponse,
  PcrsPatientLookup,
  PcrsPatientLookupParams,
  PcrsRefreshClaimStatusesParams,
  PcrsRefreshClaimStatusesResponse,
  PcrsRefreshLastRunResponse,
  PcrsSubmitClaimParams,
  PcrsSubmitClaimResponse,
} from '../types/pcrs'

export const pcrsService = {
  /**
   * Look up a patient by GMS number and code letter via the PCRS broker.
   */
  lookupPatient: async (params: PcrsPatientLookupParams): Promise<PcrsPatientLookup> => {
    const response = await api.post<PcrsPatientLookup>('/pcrs/patient-lookup', {
      ...(params.patientNum ? { patientNum: params.patientNum } : {}),
      ...(params.patientNum ? { patientCodeLetter: params.patientCodeLetter ?? 'A' } : {}),
      ...(params.ppsn ? { ppsn: params.ppsn } : {}),
    })
    return response.data
  },

  /**
   * Submit a claim to SSPCRS. Requires stcRecordId, docNum, and docNam (from assigned doctor profile or manual entry).
   */
  submitClaim: async (params: PcrsSubmitClaimParams): Promise<PcrsSubmitClaimResponse> => {
    const response = await api.post<PcrsSubmitClaimResponse>('/pcrs/submit-claim', {
      stcRecordId: params.stcRecordId,
      docNum: params.docNum,
      docNam: params.docNam,
    })
    return response.data
  },

  /**
   * Read claim status from PCRS enquiry page for a single claim number.
   */
  claimInquiry: async (params: PcrsClaimInquiryParams): Promise<PcrsClaimInquiryResponse> => {
    const response = await api.post<PcrsClaimInquiryResponse>('/pcrs/claim-inquiry', {
      claimNum: params.claimNum,
    })
    return response.data
  },

  /**
   * Refresh PCRS status for selected STC records currently in To Pay lifecycle.
   */
  refreshClaimStatuses: async (
    params: PcrsRefreshClaimStatusesParams
  ): Promise<PcrsRefreshClaimStatusesResponse> => {
    const response = await api.post<PcrsRefreshClaimStatusesResponse>('/pcrs/refresh-claim-statuses', {
      stcRecordIds: params.stcRecordIds,
    })
    return response.data
  },

  /**
   * Get last automatic PCRS refresh run info (from scheduled worker on 16th of each month).
   */
  getRefreshLastRun: async (): Promise<PcrsRefreshLastRunResponse> => {
    const response = await api.get<PcrsRefreshLastRunResponse>('/pcrs/refresh-last-run')
    return response.data
  },
}
